import { Button } from "@mui/material";
import styles from './Buttons.module.scss';

interface Props {
    id: string;
    label: any;
    onclickHandler: any;
    disabled?: boolean;
}

export default function CancelButton ({id, label, onclickHandler, disabled}: Props){
    return (
        <Button
            size="small"
            id={id}
            className={[styles.btn, styles.normalButton].join(" ")}
            onClick={onclickHandler}
            variant="outlined"
            color="error"
            disabled={disabled}
        >
            {label}
        </Button>
    )
}